import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentCreateModel, DocumentModel } from '@data-layer/models/documents';
import { enumDocumentRelatedEntityType, enumDocumentState, enumDocumentType } from '@data-layer/enums/documents';
import { Observable } from 'rxjs';
import { finalize, take } from 'rxjs/operators';

@Component({
  selector: 'isf-document-upload',
  templateUrl: './isf-document-upload.component.html',
  styleUrls: ['./isf-document-upload.component.scss'],
})
export class IsfDocumentUploadComponent {
  @Input() public isfId: number;
  @Input() public index: number;
  @Input() public document: DocumentModel;
  @Input() public isCanUploadDocuments: boolean;
  @Input() public isCanRemoveDocuments: boolean;
  @Input() public upload: (document: DocumentCreateModel, file: File) => Observable<any>;
  @Input() public remove: (documentId: number) => Observable<any>;
  @Output() public stateUpdate: EventEmitter<enumDocumentState> = new EventEmitter<enumDocumentState>();

  public enumDocumentType: typeof enumDocumentType = enumDocumentType;
  public isLoading: boolean = false;

  constructor() {}

  public get canRemoveDocuments(): boolean {
    return (
      (this.isCanRemoveDocuments ||
        [enumDocumentState.SCAN_FAILED, enumDocumentState.FILE_SIZE_TO_BIG_AFTER_SCAN].includes(this.document.state)) &&
      this.document.relatedEntityType !== enumDocumentRelatedEntityType.STATEMENT
    );
  }

  public onStateUpdate(state: enumDocumentState): void {
    this.stateUpdate.emit(state);
  }

  public onUploadDocument(file: File): void {
    if (!this.upload) {
      return;
    }
    this.isLoading = true;
    this.upload({ ...this.document, fileName: file.name }, file)
      .pipe(
        finalize(() => (this.isLoading = false)),
        take(1),
      )
      .subscribe();
  }

  public onRemoveDocument(document: DocumentModel): void {
    if (!this.remove || !this.isCanRemoveDocuments) {
      return;
    }
    this.isLoading = true;
    this.remove(document.id)
      .pipe(
        finalize(() => (this.isLoading = false)),
        take(1),
      )
      .subscribe();
  }
}
